var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',[_c('div',{staticClass:"caption"},[_vm._v("Количество отзывов за период")]),_vm._l((_vm.reviewsData),function(item){return _c('div',{key:item.name,staticClass:"months"},[_c('AnalyticsPeriodWidget',{staticClass:"month",attrs:{"data":item}})],1)}),_c('a',{attrs:{"href":""}},[_vm._v("Смотреть аналитику")])],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }